import { Component, OnInit, ViewChild } from '@angular/core';
import { DriversService } from '../../services/drivers.service';
import { CommonService } from '../../services/common.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { PassengersReportService } from '../../services/passengers-report.service';
declare var $: any;
import swal from 'sweetalert2';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { ExcelService } from '../../services/excel.service';


@Component({
  selector: 'app-driver-report',
  templateUrl: './driver-report.component.html',
  styleUrls: ['./driver-report.component.css']
})
export class DriverReportComponent implements OnInit {

  report: any = [];
  reportAux: any = [];
  filterMenuVisible: boolean = false;

  driversSettings = {};
  drivers = []
  selectedDrivers = [];


  plates: any = [];
  platesSettings = {};
  displayedColumns: string[];
  selectedPlates = [];
  dataReport2: any = [];
  dataObj: any = [];

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  constructor(
    private driversService: DriversService,
    private commonService: CommonService,
    private spinner: NgxSpinnerService,
    private excelService: ExcelService,
    private vpcReportService: PassengersReportService,

  ) { }

  ngOnInit() {
    this.getPlates();
    this.getDrivers();
    this.setFilterstData();
  }

  setFilterstData() {
    var now = new Date(); //currentDate
    this.reportAux.dateIni = { year: now.getFullYear(), month: now.getMonth() + 1, day: now.getDate() };
    this.reportAux.dateFin = { year: now.getFullYear(), month: now.getMonth() + 1, day: now.getDate() };
    this.reportAux.timeIni = '00:00';
    this.reportAux.timeFin = '23:59';
  }

  getDrivers(): void {

    this.driversSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'name',
      selectAllText: 'Todos',
      unSelectAllText: 'Deseleccionar Todos',
      itemsShowLimit: 1,
      allowSearchFilter: true,
      searchPlaceholderText: "Buscar"
    };

    this.driversService.getDrivers_rol(this.commonService.getUserName())
      .then(response => {
        console.log(response)
        this.drivers = response
      });
  }

  exportToExcel() {
    if (this.dataObj.length > 0) {
      this.excelService.exportAsExcelFile(this.dataObj, 'archivo_reporte_conductores');
    } else {
      swal({
        title: 'No hay datos para exportar',
        text: '',
        type: 'warning',
        showCancelButton: false,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#ff5370',
        confirmButtonText: 'Volver',
        // cancelButtonText: 'No'
      }).catch(swal.noop);
    }
  }

  getPlates(): void {

    this.platesSettings = {
      singleSelection: false,
      idField: 'sn_imei_id',
      textField: 'tracker_name',
      selectAllText: 'Todos',
      unSelectAllText: 'Deseleccionar Todos',
      itemsShowLimit: 1,
      allowSearchFilter: true,
      searchPlaceholderText: "Buscar"
    };

    this.spinner.show();
    this.vpcReportService.getPlates(this.commonService.getUserName()).then(response => {
      console.log(response)
      this.plates = response;
      this.plates.sort(function (a, b) {
        if (a.tracker_name > b.tracker_name) {
          return 1;
        }
        if (a.tracker_name < b.tracker_name) {
          return -1;
        }
        // a must be equal to b
        return 0;
      });

      for (var i in this.plates) {
        let licensePlate = ' - ' + this.plates[i].license_plate


        console.log('licensePlate licensePlate licensePlate licensePlate licensePlate licensePlate licensePlate : ', licensePlate)
        if (this.plates[i].license_plate == 'null' || this.plates[i].license_plate == null) { licensePlate = '' }


        this.plates[i].tracker_name = this.plates[i].tracker_name + licensePlate

        console.log('this.plates[i].tracker_name this.plates[i]this.plates[i].tracker_name this.plates[i].tracker_name :', this.plates[i].tracker_name)
      }
      // console.log('response : : : ', this.plates)
      // this.platesBuffer = this.plates.slice(0, this.bufferSize);
      // this.user_account = this.plates.user_account;
      // this.imeiVei = this.plates.sn_imei_id;
    });
    this.spinner.hide();
  }

  toggleFilterMenu() {
    this.filterMenuVisible = !this.filterMenuVisible;
  }

  setExcelData(data){
    
    let item = {}
    item["Viaje"] = data.trip
    item["Fecha"] = data.date
    item["RFID"] = data.rfid
    item["Placa"] = data.plate
    item["Conductor" ] = data.driverName

    this.dataObj.push(item)
    
  }

  setTable(data) {
    this.displayedColumns = [
      "Trip",
      "Date",
      "RFID",
      "Placa",
      "Driver",      
    ];

    // this.totalProm = 0
    // this.dataObj = []
    for (var i in data) {
      data[i].trip = +i + 1

      data[i].date = new Date(data[i].date)
      data[i].date = data[i].date.toLocaleString('es-CO', { hour12: true })

      data[i].plate = this.plates.find(o => o.sn_imei_id === data[i].imei).tracker_name;
      
      //this.totalProm += data[i].totalProm
      this.setExcelData(data[i])
    }

    this.dataReport2 = new MatTableDataSource(data);

    setTimeout(() => {
      this.forceTablePaginator()
    },
      500);

    this.dataReport2.sort = this.sort;

    // Esconde el paginador porque no es posible cambair la paginación por problemas con el componente
  }
  
  forceTablePaginator() {
    try {
      // this.dataReport2.paginator = this.paginator;
      this.dataReport2.paginator._intl.itemsPerPageLabel = "Filas por Página:"
      $(".mat-paginator-page-size").css("display", "none")
    } catch (error) {
      try {
        this.dataReport2.paginator = this.paginator;
        this.dataReport2.paginator._intl.itemsPerPageLabel = "Filas por Página:"
        $(".mat-paginator-page-size").css("display", "none")
      } catch (error) {
        console.log(error)
      }
    }
  }

  loadReport(): void {

    var d1, m1, d2, m2;
    if (this.reportAux.dateIni.day < 10) {
      d1 = '0' + this.reportAux.dateIni.day;
    } else {
      d1 = this.reportAux.dateIni.day;
    }
    if (this.reportAux.dateIni.month < 10) {
      m1 = '0' + this.reportAux.dateIni.month;
    } else {
      m1 = this.reportAux.dateIni.month;
    }
    var dateIni = d1 + '-' + m1 + '-' + this.reportAux.dateIni.year + ' ' + this.reportAux.timeIni;

    if (this.reportAux.dateFin.day < 10) {
      d2 = '0' + this.reportAux.dateFin.day;
    } else {
      d2 = this.reportAux.dateFin.day;
    }
    if (this.reportAux.dateFin.month < 10) {
      m2 = '0' + this.reportAux.dateFin.month;
    } else {
      m2 = this.reportAux.dateFin.month;
    }
    var dateFin = d2 + '-' + m2 + '-' + this.reportAux.dateFin.year + ' ' + this.reportAux.timeFin;
    dateIni = dateIni.replace(':', '_');
    dateFin = dateFin.replace(':', '_');

    var imeis = this.selectedPlates.map(({ sn_imei_id }) => "'" + sn_imei_id + "'").toString();
    var driversId = this.selectedDrivers.map(({ id }) => "'" + id + "'").toString();
    if (dateIni && dateFin) {
      this.spinner.show();
      this.vpcReportService.driverReport(imeis, driversId, dateIni, dateFin)
        .then(data => {

          console.log(data)

          this.spinner.hide();
          this.report = data;

          const quant = parseInt(data.length);
          if (quant > 0) {


          this.setTable(data)
          } else {
            $('.tbodyTable').empty();
            swal({
              title: 'No existen datos para este rango de fechas',
              text: '',
              type: 'warning',
              showCancelButton: false,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#ff5370',
              confirmButtonText: 'Volver',
              // cancelButtonText: 'No'
            }).catch(swal.noop);
          }
        })
        .catch(error => {
          this.spinner.hide();
          console.log(error)
          // console.log('vpcReport.component.error');
          swal({
            title: 'No es posible realizar la consulta, comuníquese con el administrador del sistema',
            text: '',
            type: 'error',
            showCancelButton: false,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#ff5370',
            confirmButtonText: 'Volver',
            // cancelButtonText: 'No'
          }).catch(swal.noop);
        });
    }
    else {
      this.spinner.hide();
      swal({
        title: 'Ingresa Todos los campos solicitados',
        text: '',
        type: 'error',
        showCancelButton: false,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#ff5370',
        confirmButtonText: 'Volver',
        // cancelButtonText: 'No'
      }).catch(swal.noop);
    }
  }

}



// WEBPACK FOOTER //
// D:/projects/passengerControlFront/passengerControlApp/src/app/components/driver-report/driver-report.component.ts